import { gql } from '@apollo/client';

const schema = {
  list: {
    name: "orderStep",
    serviceName: "auth",
    query: gql`
      query orderStep(
        $ids: [String]
        $title: String
        $depth: Int
        $category_id: String
        $orderBy_field: String
        $walk_direction: String
        $orderBy_direction: String
      ) {
        orderStep(
          ids: $ids
          title: $title
          depth: $depth
          category_id: $category_id
          orderBy_field: $orderBy_field
          walk_direction: $walk_direction
          orderBy_direction: $orderBy_direction
        ) {
          total
          last_page
          data {
            id
            title
            parent {
              id
              title
            }
            children {
              id
              title
              parent {
                id
                title
              }
              children {
                id
              }
            }
          }
        }
      }
    `,
  },
  assignment: {
    name: "orderStep",
    serviceName: "auth",
    query: gql`
      query orderStep($ids: [String]) {
        orderStep(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
